export default __webpack_public_path__ + "i18n/es.765fb8f618b794ccb5b9d3b099947ed1.json";